<template>
    <div class="exchange_detail">
        <div v-if="detail">
            <Swipe indicator-color="#FF7B4E">
                <SwipeItem v-for="(src, index) in detail.imgurl" :key="index">
                    <van-image :src="src" lazy-load width="7.5rem" fit="contain">
                        <template v-slot:loading>
                            <Loading type="spinner" size="30"/>
                        </template>
                    </van-image>
                </SwipeItem>
            </Swipe>

            <div class="exchange_detail_body">
                <div class="exchange_detail_info">
                    <div>
                        <div class="van-ellipsis">{{detail.name}}</div>
                    </div>
                    <div>
                        <div>
                            <img :src="require('assets/img/common/coin.png')" class="coin" alt="">
                            {{detail.sellingpoints}}
                            <template v-if="detail.sellingprice*1>0">
                                <span>+ </span><span>¥</span>{{detail.sellingprice}}
                            </template>
                        </div>
                        <del v-if="detail.originalprice">
                            ¥ {{detail.originalprice}}
                        </del>
                    </div>
                </div>

                <div class="exchange_detail_intro">
                    <div v-html="detail.intro"></div>
                </div>
            </div>
        </div>

        <Loading type="spinner" size="24px" vertical v-else/>
        <GoodsAction>
            <!-- <GoodsActionIcon icon="star" text="已收藏" color="#ff5000" @click="like" v-if="detail.state==1"/>
            <GoodsActionIcon icon="star" text="收藏" @click="like" v-else/> -->
            <GoodsActionButton color="linear-gradient(to right, #2F7BE8, #82BBFD)" type="danger" :text="detail.tips" :disabled="detail.disabled==true" @click="toggleSheet" />
        </GoodsAction>
        <Sku :skushow="skushow" :SkuInfo="detail" @closeSheet="toggleSheet" @preBuy="preBuy"></Sku>
    </div>
</template>
<script>
    import './index.less'
    import {Loading, Swipe, SwipeItem, Image} from 'vant'
    import {GoodsAction, GoodsActionIcon, GoodsActionButton, ActionSheet} from 'vant'
    import Sku from '@/views/Exchange/Sku'

    export default {
        name: "exchangeDetail",
        data() {
            return {
                sku:{
                    stock:0,
                    choice:0,
                },
                detail: {
                    imgurl:[]
                },
                goodsid: '',
                skushow: false
            }
        },
        components: {
            Loading,
            Swipe,
            SwipeItem,
            GoodsAction,
            GoodsActionIcon,
            GoodsActionButton,
            ActionSheet,
            vanImage: Image,
            Sku

        },
        props: {
            goodsList: Array
        },
        methods: {
            preBuy:function(e){
                //保存缓存?因为参数太多路由
                this.$api.pay.prePayorder(e).then((res)=>{
                    if(res.status*1===200){
                        this.$router.push({name:'orderConfirm',params:{orderid:res.data.id}})
                    }
                })
                this.toggleSheet()
            },
            toggleSheet:function(){
              this.skushow = this.skushow?false:true
            },
            like: function () {
                let detail = this.detail
                detail.state = detail.state == 1 ? 2 : 1;
                this.$api.exchange.likeGoods({
                    gid: this.goodsid,
                    state: detail.state
                }).then((res) => {
                    if (res.status == 200) {
                        this.detail = detail
                    }
                })
            },

            getDetail() {
                this.$api.exchange.goodsDetail({goodsid: this.goodsid}).then((res) => {
                    console.log(res.data);
                    if (res.status * 1 === 200) {
                        this.detail = res.data
                    }
                });
            }
        },
        mounted() {
            this.goodsid = this.$route.params.goodsid;
            this.$nextTick(() => {
                this.getDetail();
            })
        }
    }
</script>
